// extracted by mini-css-extract-plugin
export var legendIndicator = "_gq-1";
export var legendRight = "_gq-0";